export default __webpack_public_path__ + "static/media/pic1.247f0980.svg";